(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.brand-header__read-more');
    if (!btn) return;
    var target = document.getElementById(btn.dataset.target);
    if (!target) return;
    var expanded = target.classList.toggle('expanded');
    btn.textContent = expanded ? 'Read less' : 'Read more';
  });

  } catch(e) { console.error(e); }
})();
})();
